import React, { type ReactNode } from "react";
import { Flex, Box, Text } from "@chakra-ui/react";

type KeyLabelProps = {
  color: string;
  children: ReactNode;
};

export function KeyLabel({ color, children }: KeyLabelProps) {
  return (
    <Flex align="center" gap={{ base: "4px", lg: "6px" }}>
      <Box boxSize={{ base: "8px", lg: "12px" }} bg={color} borderRadius="2px" />
      <Text fontSize={{ base: "brand.2xs", lg: "brand.xs" }} fontWeight="semibold" lineHeight="none">
        {children}
      </Text>
    </Flex>
  );
}
